import React from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";

import temaFormulario from "../../Styles/Temas/temaFormulario";

export default function ModalInfo({
    open = false,
    fechar = () => { },
    titulo = 'Atenção',
    texto = 'Alguma informação',
    textoComponent = null
}) {
    return (
        <MuiThemeProvider theme={temaFormulario}>
            <Dialog
                open={open}
                fullWidth
                maxWidth={'xs'}
                onClose={fechar}
                aria-labelledby="modal-info"
            >
                <DialogTitle id="modal-info">
                    {titulo}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ wordBreak: "break-word", whiteSpace: 'pre-line' }}>
                        {textoComponent !== null ? textoComponent : texto}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id="button_fechar_info"
                        variant="text"
                        onClick={fechar}
                    >
                        Fechar
                    </Button>                    
                </DialogActions>
            </Dialog>
        </MuiThemeProvider>
    );
}
